module.exports = __webpack_public_path__ + "img/bluebot_intro.5554f1c5.png";